import CryptoJS from 'crypto-js'

/**
 * 与后端 com.tieshou.ironbeast.util.AESEncryptUtil 保持完全一致：
 * 算法 AES/ECB/PKCS5Padding（等价 PKCS7），密钥取 SECRET_KEY 前 16 字节，密文 Base64 输出。
 * 注意：必须用 Utf8.parse 后的 WordArray 作为 key，否则 crypto-js 会走 OpenSSL 口令派生，
 * 密文会带 "Salted__" 头，与后端无法互通。
 */
const SECRET_KEY = 'tieshou_yundong_1'
const KEY = CryptoJS.enc.Utf8.parse(SECRET_KEY.substring(0, 16))

/**
 * AES 加密（ECB/PKCS7，输出 Base64）
 * @param {String} plainText 明文
 * @returns {String} Base64 密文；空值原样返回
 */
export function aesEncrypt(plainText) {
  if (plainText === null || plainText === undefined || plainText === '') {
    return plainText
  }
  const encrypted = CryptoJS.AES.encrypt(String(plainText), KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

/**
 * AES 解密（ECB/PKCS7，输入 Base64 密文）
 * 解密失败时回退原值，兼容历史明文数据，避免表格出现空白
 * @param {String} cipherText Base64 密文
 * @returns {String} 明文
 */
export function aesDecrypt(cipherText) {
  if (cipherText === null || cipherText === undefined || cipherText === '') {
    return cipherText
  }
  try {
    // 显式构造 CipherParams，避免 crypto-js 按 OpenSSL 格式解析导致误判 salt
    const cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(String(cipherText))
    })
    const decrypted = CryptoJS.AES.decrypt(cipherParams, KEY, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    const plainText = decrypted.toString(CryptoJS.enc.Utf8)
    return plainText || String(cipherText)
  } catch (e) {
    return String(cipherText)
  }
}
